import { Component } from '@angular/core';

@Component({
    selector: 'app-overlay',
    templateUrl: './overlay.component.html',
    styleUrl: './overlay.component.scss',
    standalone: false
})
export class OverlayComponent {
}